"use client";
import { useContext } from "react";
import AngleDetector from "./AngleDetector";
import CameraPermission from "./CameraPermission";
import Modal from "../Modal";
import { Drawer } from "@mui/material";
import ScanErrorMessage from "./ScanErrorMessage";
import LoadingScreen from "../LoadingScreen";
import SignUp from "../Signup";
import { useConfig } from "../../utils/context/configContext";
import ParamsContext from "../../utils/context/paramsContext";

export const BodyScanSteps = () => {
	const {
		userDetails,
		onRetry,
		isError,
		isSuccess,
		gender,
		scanUniqueKey,
		scanFailsError,
		setScanUniqueKey,
		setIsVideoUploaded,
		isMeasurementAvailable,
		isVideoUploadedCorrect,
		loading,
		showDeniedModal,
		uploadLoading,
		setScanFailsError,
		setScanStartTime,
		resetScan,
		onCustomScanSuccess,
		swan,
		onComplete,
	} = useContext(ParamsContext);
	const resolvedConfig = useConfig();

	if (isError) {
		return (
			<div data-scan-state="error">
				<CameraPermission />
				<Drawer
					anchor="bottom"
					open={true}
					className="camera-drawer"
					onClose={(event, reason) => {
						if (reason === "backdropClick") {
							return;
						}
					}}
				>
					<ScanErrorMessage scanFailsError onNext={onRetry} gender={gender} />
				</Drawer>
			</div>
		);
	}

	if (isSuccess) {
		return <div data-scan-state="success"><SignUp isSuccess onComplete={onComplete} /></div>;
	}

	if (loading) {
		return (
			<div data-scan-state="loading" className="flex top-0 !mt-0 left-0 z-[999]  absolute justify-center items-center w-full h-full" style={{ background: resolvedConfig?.style?.base?.backgroundColor }}>
				<LoadingScreen url={resolvedConfig?.loader} loaderType="black" />
			</div>
		);
	}
	if (showDeniedModal.disabled) {
		return <div data-scan-state="camera-denied"><Modal /></div>;
	}

	if (!uploadLoading && !scanFailsError && !isMeasurementAvailable && !isVideoUploadedCorrect) {
		return (
			<div data-scan-state="scanning">
			<AngleDetector
				scanID={scanUniqueKey}
				userDetails={userDetails}
				setIsVideoUploaded={setIsVideoUploaded}
				setScanFailsError={setScanFailsError}
				setScanStartTime={setScanStartTime}
				setScanUniqueKey={setScanUniqueKey}
			/>
			</div>
		);
	}
	if ((uploadLoading || isMeasurementAvailable || isVideoUploadedCorrect) && !scanFailsError) {
		return (
			<div data-scan-state="processing">
			<SignUp
				scanId={scanUniqueKey}
				isMeasurementAvailable={isMeasurementAvailable}
				userDetails={userDetails}
				isVideoUploadedCorrect={isVideoUploadedCorrect}
				onCustomScanSuccess={onCustomScanSuccess}
				swan={swan}
				onComplete={onComplete}
			/>
			</div>
		);
	}
	return (
		<div data-scan-state="error-retry">
			<CameraPermission />
			<Drawer
				anchor="bottom"
				open
				className="camera-drawer"
				onClose={(event, reason) => {
					if (reason === "backdropClick") {
						return;
					}
				}}
			>
				<ScanErrorMessage
					scanFailsError={scanFailsError}
					onNext={() => {
						onRetry?.();
						resetScan();
					}}
					setScanUniqueKey={setScanUniqueKey}
					gender={gender}
					setIsVideoUploaded={setIsVideoUploaded}
				/>
			</Drawer>
		</div>
	);
};
